import axios from 'axios';

const state = {
  order: {},
  page: { docs: [], totalPages: 0, page: 1 }
};

const getters = {
  getOrder: state => state.order,
  getPageContent: state => state.page.docs,
  getTotalPages: state => state.page.totalPages,
  getTotalElemnts: state => state.page.totalDocs,
  getCurrentPage: state => state.page.page
};
const actions = {
  loadPage: async ({ commit, rootGetters }, params) => {
    const customer = rootGetters['auth/getCustomerId'];

    return new Promise(
      (resolve, reject) => {
        axios
          .get(`/api/customers/${customer}/orders`, { params: params })
          .then(response => {
            commit('FETCH_ORDER_PAGE_SUCCESS', response.data);
            resolve();
          });
      },
      error => {
        reject(error);
      }
    );
  },
  getOrderById: ({ commit }, orderId) => {
    return new Promise(
      (resolve, reject) => {
        axios.get(`/api/orders/${orderId}`).then(response => {
          commit('FETCH_ORDER_SUCCESS', response.data);
          resolve(response.data);
        });
      },
      error => {
        reject(error);
      }
    );
  },
  getPdf: ({ commit }, orderId) => {
    return new Promise(
      (resolve, reject) => {
        axios({
          method: 'get',
          url: `/api/orders/${orderId}/pdf`,
          responseType: 'arraybuffer',
          data: { test: 123 }
        }).then(response => {
          resolve(response.data);
        });
      },
      error => {
        reject(error);
      }
    );
  }
};
const mutations = {
  ['FETCH_ORDER_PAGE_SUCCESS']: (state, payload) => {
    state.page = payload;
  },
  ['FETCH_ORDER_SUCCESS']: (state, payload) => {
    state.order = payload;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
